import { render, staticRenderFns } from "./lkuKoranCust.vue?vue&type=template&id=40f280ee"
import script from "./lkuKoranCust.vue?vue&type=script&lang=js"
export * from "./lkuKoranCust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports